import { ReactNode } from 'react';
import { Tokens } from '@chakra-ui/react';

import { Box, Icon, Tooltip, TooltipProps } from '../../chakra';
import { IconType } from '../../icons';

export interface IconTooltipProps {
  content: ReactNode;
  size?: TooltipProps['size'];
  colour: Tokens['colors'];
  icon: IconType;
  iconSize?: number;
  'data-testid'?: string;
}

export function IconTooltip({ content, size, colour, icon, iconSize = 4, 'data-testid': testId }: IconTooltipProps) {
  return (
    <Tooltip content={content} size={size} portalled>
      {/*
       This wrapper forces the icon onto the same line as the text content that precedes it
        It also provides the ref for the `Tooltip` to anchor onto
      */}
      {/* eslint-disable-next-line i18next/no-literal-string -- content for ::before */}
      <Box data-testid={testId} as="span" whiteSpace="nowrap" _before={{ content: '" "' }} tabIndex={0}>
        <Icon
          color={colour}
          // Use a standard size
          w={iconSize}
          h={iconSize}
          // Vertical align middle tends to align to the middle of text including down extenders
          // (the bits which extend below the line)
          // So we bump it up ever so slightly to look more natural
          verticalAlign="middle"
          marginBottom={1}
          cursor="help"
          as={icon}
        />
      </Box>
    </Tooltip>
  );
}
